import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import api, { RetailerVendorLogDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface RetailerVendorLogsGridProps {
  retailerId?: string;
  vendorId?: string;
  onRowSelected?: (row: RetailerVendorLogDto | null) => void;
}

const columns: GridColDef<RetailerVendorLogDto>[] = [
  { field: "eventName", headerName: "Event", width: 100, editable: false, sortable: true, filterable: false },
  { field: "log", headerName: "Log", minWidth: 200, flex: 400, editable: false, sortable: false, filterable: false },
  { field: "isError", headerName: "error", width: 60, editable: false, sortable: true, filterable: false, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
  { field: "createdAt", headerName: "time", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
];

export const RetailerVendorLogsGrid = (props: RetailerVendorLogsGridProps) => {
  const { retailerId, vendorId, onRowSelected } = props;

  const loadData = async (page: number, size: number, sort: string): Promise<PaginationData<RetailerVendorLogDto>> => {
    if (vendorId) {
      return await api.retailerVendor.logs({ page, size, sort, retailerId, vendorId } as any);
    }
    return { data: [], count: 0 } as any;
  };

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowSelected={onRowSelected} />;
};
